import React from 'react';

export default function Blog018() {
  return (
    <section>
    <article>
      <h2>18. 10-04-2022</h2>
      <h3>New Office</h3>
      <p>
        <br />
      <strong>Howdy!</strong>
      <br />
        <br />
        It has been a minute since I have last updated this blog, and as the title may suggest, 
        the pause had a good purpose. Though my computer has been unplugged and I have not written 
        code for a few days; the purpose of my pause is to increase my programming productivity for 
        the foreseeable future. With a proper office I may work longer hours and produce more results. 
        <br />
        <br />
        <strong>The new Office</strong>
        <br />
        <br />
        I have moved my office supplies to the basement. Is that it? NO no no. First I repaired 
        the foundation with four hundred pounds of concrete. I then painted the entire 380sq ft 
        basement with 5 gallons of concrete sealant. I decided to go with a bright white color, 
        after some convincing from my daughter. My wife and I would have gone with black, but white is 
        a more rational decision. 
        <br />
        As with any home project, this took a bit longer than expected. The best part is, it is done. 
        I am currently using my main PC in the basement office to write this blog. 
        <br />
        <br />
     
        <strong>And with that</strong>
        <br /><br />
        I am back in business, ready to get rocking and rolling on some code. I will update 
        all my progress here, as well as on my youtube channel. I will have a new vlog update 
        soon! 

     
      </p>
    </article>

    <h4>Links</h4>
    <br />
    <ul>

      <li>
        <a
          href="http://youtube.com/erpolley"
          target="_blank"
          title="My Youtube"
          rel="noopener noreferrer" 
        >
          <strong><p>Check out my Youtube Channel</p></strong></a
        >
      </li>
      <li>
        <a
          href="http://ericpolley.com"
          target="_blank"
          title="My website"
          rel="noopener noreferrer" 
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>

    </ul>
  </section>
  )
}
